// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  --page-margin: var(--app-narrow-margin);
  --page-border-radius: var(--app-fair-radius);
  --page-actions-padding: 5px;
  --page-friends-gutter: calc(var(--page-margin) / 2);
  --page-pictures-gutter: calc(var(--page-margin) / 2);
}

.viewpoints-section {
  margin: 20px;
  padding-bottom: var(--page-margin);
}
.viewpoints-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
}
.viewpoints-section .heading-row .section-title {
  margin: 0px;
  /*             flex-basis: 75%; */
  font-size: 24px;
  font-weight: 500;
  color: var(--ion-color-dark-tint);
  margin: 0px 0px var(--page-margin);
}
.viewpoints-section .heading-row .section-description {
  margin: 0;
}
.viewpoints-section .heading-row .heading-call-to-action {
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.viewpoints-section .viewpoints-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  /*     margin-left: calc(var(--page-margin) * -1); */
  margin-right: -20px;
  height: 320px;
  flex-flow: column wrap;
}
.viewpoints-section .viewpoints-row .viewpoint-item {
  display: flex;
  align-items: center;
  /* Alinea los elementos verticalmente */
  gap: 10px;
  /* Espacio entre los elementos */
  max-height: 80px;
  --col-item-width: 6;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px 12px;
  /* Consider renaming this variable to something more generic */
}
.viewpoints-section .viewpoints-row .viewpoint-index {
  font-weight: bold;
}
.viewpoints-section .viewpoints-row .viewpoint-image-container {
  width: 50px;
  height: 50px;
  /* Evita que la imagen se reduzca */
}
.viewpoints-section .viewpoints-row .viewpoint-picture {
  width: 50px;
  height: 50px;
  object-fit: cover;
  /* Asegura que la imagen cubra completamente el área sin perder su proporción */
}
.viewpoints-section .viewpoints-row .viewpoint-text {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}
.viewpoints-section .viewpoints-row .viewpoint-visit-count {
  display: block;
}
.viewpoints-section .viewpoints-row .viewpoint-options {
  margin-left: auto;
  margin-right: 8px;
  /* Empuja el icono de opciones hacia la derecha */
}

app-image-shell.viewpoint-picture {
  --image-shell-border-radius: var(--page-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/app/components/posts/top-viewpoints-monthly/top-viewpoints-monthly.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EACI,uCAAA;EACA,4CAAA;EAEA,2BAAA;EACA,mDAAA;EACA,oDAAA;AAJJ;;AAOA;EACI,YAAA;EACA,kCAAA;AAJJ;AAMI;EACI,iCAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJR;AAMQ;EACI,WAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,kCAAA;AAJZ;AAOQ;EACI,SAAA;AALZ;AAQQ;EACI,qBAAA;EACA,iCAAA;AANZ;AAUI;EACI,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,oDAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;AAVR;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,SAAA;EACA,gCAAA;EAEA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,uEAAA;EACA,2EAAA;EACA,iBAAA;EACA,8DAAA;AAZZ;AAeQ;EACI,iBAAA;AAbZ;AAgBQ;EACI,WAAA;EACA,YAAA;EACA,mCAAA;AAdZ;AAiBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,+EAAA;AAfZ;AAkBQ;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAhBZ;AAmBQ;EACI,cAAA;AAjBZ;AAoBQ;EACI,iBAAA;EACA,iBAAA;EACA,iDAAA;AAlBZ;;AAwBA;EACI,sDAAA;AArBJ","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n@import \"theme/mixins/inputs/select-alert\";\r\n\r\n// Custom variables\r\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\r\n:host {\r\n    --page-margin: var(--app-narrow-margin);\r\n    --page-border-radius: var(--app-fair-radius);\r\n\r\n    --page-actions-padding: 5px;\r\n    --page-friends-gutter: calc(var(--page-margin) / 2);\r\n    --page-pictures-gutter: calc(var(--page-margin) / 2);\r\n}\r\n\r\n.viewpoints-section {\r\n    margin: 20px;\r\n    padding-bottom: var(--page-margin);\r\n\r\n    .heading-row {\r\n        margin-bottom: var(--page-margin);\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding-left: 12px;\r\n\r\n        .section-title {\r\n            margin: 0px;\r\n            /*             flex-basis: 75%; */\r\n            font-size: 24px;\r\n            font-weight: 500;\r\n            color: var(--ion-color-dark-tint);\r\n            margin: 0px 0px var(--page-margin);\r\n        }\r\n\r\n        .section-description {\r\n            margin: 0;\r\n        }\r\n\r\n        .heading-call-to-action {\r\n            text-decoration: none;\r\n            color: var(--ion-color-secondary);\r\n        }\r\n    }\r\n\r\n    .viewpoints-row {\r\n        --ion-grid-columns: 7;\r\n        --ion-grid-column-padding: 0px;\r\n\r\n        flex-wrap: nowrap;\r\n        overflow-x: scroll;\r\n        will-change: scroll-position;\r\n        /*     margin-left: calc(var(--page-margin) * -1); */\r\n        margin-right: -20px;\r\n\r\n        height: 320px;\r\n        flex-flow: column wrap;\r\n\r\n\r\n        .viewpoint-item {\r\n            display: flex;\r\n            align-items: center;\r\n            /* Alinea los elementos verticalmente */\r\n            gap: 10px;\r\n            /* Espacio entre los elementos */\r\n\r\n            max-height: 80px;\r\n            --col-item-width: 6;\r\n            flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            padding: 0px 12px;\r\n            /* Consider renaming this variable to something more generic */\r\n        }\r\n\r\n        .viewpoint-index {\r\n            font-weight: bold;\r\n        }\r\n\r\n        .viewpoint-image-container {\r\n            width: 50px;\r\n            height: 50px;\r\n            /* Evita que la imagen se reduzca */\r\n        }\r\n\r\n        .viewpoint-picture {\r\n            width: 50px;\r\n            height: 50px;\r\n            object-fit: cover;\r\n            /* Asegura que la imagen cubra completamente el área sin perder su proporción */\r\n        }\r\n\r\n        .viewpoint-text {\r\n            display: flex;\r\n            flex-direction: column;\r\n            font-size: 14px;\r\n        }\r\n\r\n        .viewpoint-visit-count {\r\n            display: block;\r\n        }\r\n\r\n        .viewpoint-options {\r\n            margin-left: auto;\r\n            margin-right: 8px;\r\n            /* Empuja el icono de opciones hacia la derecha */\r\n        }\r\n\r\n    }\r\n}\r\n\r\napp-image-shell.viewpoint-picture {\r\n    --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
